import { pubsub } from '@services';
import { getCurrentComparisonData } from '@utils';

class ComparisonDrawerToggle extends HTMLElement {
  connectedCallback() {
    this.currentAmountElement = this.querySelector('[data-current-amount]');
    if (!this.currentAmountElement) return;
    this.init();
    this.unsubScribeToCurrentAmount = pubsub.subscribe('comparison:update', ({ newAmount }) =>
      this.updateCurrentAmount(newAmount),
    );
  }

  disconnectedCallback() {
    if (!this.unsubScribeToCurrentAmount) return;
    this.unsubScribeToCurrentAmount();
  }

  init() {
    const currentComparisonData = getCurrentComparisonData();
    this.updateCurrentAmount(currentComparisonData.length);
  }

  updateCurrentAmount(newAmount) {
    this.currentAmountElement.innerText = newAmount;
  }
}

customElements.define('compare-drawer-toggle', ComparisonDrawerToggle);
